/**
 * Display labels for the Steckbrief's enum fields (NC-1383 item 4).
 *
 * `usage.frequency` was the one enum row that did not go through a label map:
 * `ProfileStepUsage` carried its own inline FREQUENCIES array for the dropdown,
 * while `ProfileReadView` printed the stored value raw. Its members happen to be
 * German words, so nothing looked broken — it was still the single place where the
 * storage format leaked into the UI, and the two sides could drift.
 *
 * One source for both. The KEYS are the zod enum members from
 * api/shared/workloadProfileValidation.ts — never translate a key, only its label.
 */

import { ProfileFrequency } from '../../../services/types';

export const FREQUENCY_LABEL: Record<ProfileFrequency, string> = {
  einmalig: 'Einmalig',
  monatlich: 'Monatlich',
  quartalsweise: 'Quartalsweise',
  jaehrlich: 'Jährlich',
  laufend: 'Laufend',
};

/**
 * Dropdown order for the wizard. Explicit because the key order of a Record is
 * not something to rely on for presentation.
 */
export const FREQUENCY_ORDER: readonly ProfileFrequency[] = [
  'einmalig',
  'monatlich',
  'quartalsweise',
  'jaehrlich',
  'laufend',
];
